import script from "./Design.vue?vue&type=script&setup=true&lang=js"
export * from "./Design.vue?vue&type=script&setup=true&lang=js"

import "./Design.vue?vue&type=style&index=0&id=464b9f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464b9f88"]])

export default __exports__